import React from "react";

export const AppContext = React.createContext({ loggedInUserId: "No User" });

export const AppProvider = AppContext.Provider;
export const AppConsumer = AppContext.Consumer;
